import {
  ChatIdFromSlug,
  QueryChatIdFromSlugArgs,
} from '@tribeplatform/gql-client/types'

import { UseQueryOptions, useQuery } from '../../index.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatIdFromSlugKey } from '../../utils/keys/messaging.key.js'

export const useGetChatIdFromSlug = (options: {
  variables: QueryChatIdFromSlugArgs
  useQueryOptions?: UseQueryOptions<ChatIdFromSlug>
}) => {
  const { variables, useQueryOptions } = options

  const { client } = useTribeClient()
  const chatKey = getChatIdFromSlugKey({ variables })

  return useQuery<ChatIdFromSlug>(
    chatKey,
    () => client.messaging.chatIdFromSlug(variables),
    {
      ...useQueryOptions,
    },
  )
}
